import { Location } from "@navigation";
import React from "react";
import { CustomerContractPriceListEditor } from "../CustomerContractPriceListEditor/CustomerContractPriceListEditor";

interface Params {
  contractId: string;
  priceListId?: string;
  isDuplicate?: boolean;
}

export class CustomerContractPriceListEditorLocation extends Location<Params> {
  constructor(contractId: string, priceListId: string, isDuplicate?: boolean) {
    super({ contractId, priceListId, isDuplicate });
  }

  render() {
    return (
      <CustomerContractPriceListEditor
        contractId={this.params.contractId}
        priceListId={this.params.priceListId}
        isDuplicate={this.params.isDuplicate}
      />
    );
  }

  toURI(): string {
    const { contractId, priceListId } = this.params;
    return `/customer_contracts/${contractId}/price_lists/${priceListId || "new"} `;
  }
}
